import { render, staticRenderFns } from "./studentIndex.vue?vue&type=template&id=4d6c0528&"
import script from "./studentIndex.vue?vue&type=script&lang=js&"
export * from "./studentIndex.vue?vue&type=script&lang=js&"
import style0 from "./studentIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports